import { OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
var InputComponent = /** @class */ (function () {
    function InputComponent() {
        this.applyPipes = true;
        this.type = 'text';
    }
    InputComponent.prototype.ngOnInit = function () { };
    Object.defineProperty(InputComponent.prototype, "isRequired", {
        get: function () {
            if (this.control.validator) {
                var validator = this.control.validator({});
                if (validator && validator.required) {
                    return true;
                }
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    return InputComponent;
}());
export { InputComponent };
